import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnswerAttachment } from '@app/dashboard/shared/models/audit-collection-response';
import { announcementouter, deleteIcon } from '@app/shared/customSVGIcons/custom-svg';
import { StringConstants } from '@app/shared/string-constants';
import { NotificationService } from '@progress/kendo-angular-notification';
import { FileRestrictions, SelectEvent } from '@progress/kendo-angular-upload';
import { SVGIcon, trashIcon, uploadIcon } from '@progress/kendo-svg-icons';

@Component({
	selector: 'kpa-file-upload',
	templateUrl: './file-upload.component.html',
	styleUrl: './file-upload.component.scss',
})
export class FileUploadComponent implements OnInit {
	@Output() fileAdded = new EventEmitter<{ file: File; questionId: number }>();
	@Output() fileRemoved = new EventEmitter<AnswerAttachment>();
	@Input() questionAttachments: AnswerAttachment[] = [];
	selectedImage: { url: string } | null = null;
	images: { url: string }[] = [];
	@Input() questionId: number;
	public uploadIcon: SVGIcon = uploadIcon;
	public deleteIcon: SVGIcon = trashIcon;
	public validationErrorMessages = {
		invalidMaxFileSize: 'The file exceeds the maximum allowed size.',
		invalidMinFileSize: 'The file is smaller than the minimum allowed size.',
		invalidFileExtension: 'The file type is not supported.',
	};
	constructor(private notificationService: NotificationService) {}

	public onSelect(event: SelectEvent): void {
		for (let file of event.files) {
			if (file.validationErrors) {
				const errorMessages = file.validationErrors.map((error) => this.validationErrorMessages[error] || error);
				this.notificationService.show({
					content: errorMessages.join(','),
					hideAfter: StringConstants.hideFileNotificationAfter,
					position: { horizontal: 'center', vertical: 'bottom' },
					animation: { type: 'fade', duration: 400 },
					type: { style: 'error', icon: true },
				});
				return;
			}
			const reader = new FileReader();
			reader.onload = (e: any) => {
				this.images.push({ url: e.target.result });
				this.fileAdded.emit({ file: file.rawFile, questionId: this.questionId });
			};
			reader.readAsDataURL(file.rawFile);
		}
	}
	public fileRestrictions: FileRestrictions = {
		allowedExtensions: ['.png', '.jpeg', '.jpg', '.bmp'],
	};

	ngOnInit(): void {
		this.images = this.questionAttachments.map((attachment) => ({
			url: attachment.imageUrl,
		}));
	}
	viewImage(image: { url: string }) {
		this.selectedImage = image;
	}

	removeImage(index: number): void {
		const removedImage = this.images.splice(index, 1)[0];
		const removedAttachment = this.questionAttachments.find((att) => att.imageUrl === removedImage.url);
		if (removedAttachment) {
			this.fileRemoved.emit(removedAttachment);
		}
	}

	closeDialog() {
		this.selectedImage = null;
	}
}
